module.exports = __webpack_public_path__ + "static/media/zimbabwe-shipping-map.f4893a72.jpg";